import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';

import './config/ReactotronConfig';
import Context from './context';
import Routes from './routes';
import history from './services/history';
import { store, persistor } from './store';
import GlobalStyle from './styles/global';

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <Context>
            <GlobalStyle />
            <Routes />
            <ToastContainer autoClose={3000} style={{ zIndex: '999999' }} />
          </Context>
        </Router>
      </PersistGate>
    </Provider>
  );
}
